module.exports = __webpack_public_path__ + "static/img/coin.e71b7ac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coin.gif
// module id = Ml3w
// module chunks = 1